import * as angular from 'angular';
import {IPromise, IQService} from 'angular';
import * as _ from "lodash";
import {HolderType} from "../../commons/types/holder.type";
import {DocumentSettings} from "../models/document-settings.model";
import {ReminderSettings} from "../models/reminder-settings.model";
import {AbsenceReasonSettings} from "../models/absence-reason-settings.model";
import {BreakType} from "../models/break-type.model";
import {BringozLoaderService} from "../../commons/services/bringoz-loader.service";
import {VehicleStatusChangeReasonSettingsEntity} from "../models/vehicle-status-change-reason-settings.model";
import {PackageConfigurationEntity} from "../models/package-configuration.model";
import {PackageConfigurationsRequestsService} from "./package-configurations-requests.service";
import {DefaultPackageConfigurationFieldsType} from "../types/default-package-configuration-fields.type";
import {SplitService} from "../../commons/services/split-service.service";
import {PreferencesRequestsService} from "./preferences-requests.service";
import {SettingsAlertsService} from "./settings-alerts.service";
import {SettingsRequestsService} from "./settings-requests.service";
import {
  SHIPPER_APP_CUSTOMER_CONFIGURATION,
  SHIPPER_APP_ORDER_CONFIGURATION, SHIPPER_APP_PAYMENT_CONFIGURATION
} from "../models/shipper-portal-configuration";
import {CustomFieldModel} from "../models/custom-field.model";

export class SettingsService {

  /* @ngInject */
  constructor(private settingsRequestsService: SettingsRequestsService, private settingsAlertsService: SettingsAlertsService, private $q: IQService, private bringozLoaderService: BringozLoaderService,
              private preferencesRequestsService: PreferencesRequestsService, private splitService: SplitService, private packageConfigurationsRequestsService: PackageConfigurationsRequestsService) {
  }

  getSiteMetadata() {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.settingsRequestsService.getSiteMetadata()
      .then((metaData) => {
        const accountLocalSettings = this.splitService.getSiteAccountSettings();
        const omsLocalSettings = this.splitService.getSiteOmsSettings();
        const deliveryLocalSettings = this.splitService.getSiteDeliverySettings();
        const fulfillmentLocalSettings = this.splitService.getSiteFulfillmentSettings();
        const packageDetailsLocalSettings = this.splitService.getSitePackageDetailsSettings();
        const thirdPartyServiceLocalSettings = this.splitService.getSite3plServiceSettings();
        const routeLocalSettings = this.splitService.getSitePlanningRoutesSettings();
        const fulfillmentStepLocalSettings = this.splitService.getSiteFulfillmentStepSettings();

        if (!accountLocalSettings.dynamicColumns) {
          accountLocalSettings.dynamicColumns = [];
        }
        if (!omsLocalSettings.dynamicColumns) {
          omsLocalSettings.dynamicColumns = [];
        }
        if (!deliveryLocalSettings.dynamicColumns) {
          deliveryLocalSettings.dynamicColumns = [];
        }
        if (!deliveryLocalSettings.taskDynamicColumns) {
          deliveryLocalSettings.taskDynamicColumns = [];
        }
        if (!fulfillmentLocalSettings.dynamicColumns) {
          fulfillmentLocalSettings.dynamicColumns = [];
        }
        if (!packageDetailsLocalSettings.packageDynamicColumns) {
          packageDetailsLocalSettings.packageDynamicColumns = [];
        }

        if (!thirdPartyServiceLocalSettings) {
          thirdPartyServiceLocalSettings.dynamicColumns = [];
        }

        if (!routeLocalSettings?.dynamicColumns) {
          routeLocalSettings.dynamicColumns = [];
        }
        if (!fulfillmentStepLocalSettings.dynamicColumns) {
          fulfillmentStepLocalSettings.dynamicColumns = [];
        }

        const accountMetadata = _.chain(metaData)
          .filter((m) => {
            return (m.holder === 'ACCOUNT') && !!m.active
          })
          .map((activeMetadata) => {
            const currentMetadataValue = _.find(accountLocalSettings.dynamicColumns, (c) => {
              return c.id === activeMetadata.id;
            });
            const activeMetadataCopy = angular.copy(activeMetadata);
            activeMetadataCopy.enabled = _.get(currentMetadataValue, 'enabled', false) // enable on display

            return activeMetadataCopy;
          })
          .value();

        const omsMetadata = _.chain(metaData)
          .filter((m) => {
            return m.holder === 'OMS' && !!m.active
          })
          .map((activeMetadata) => {
            const currentMetadataValue = _.find(omsLocalSettings.dynamicColumns, (c) => {
              return c.id === activeMetadata.id;
            });
            const activeMetadataCopy = angular.copy(activeMetadata);
            activeMetadataCopy.enabled = _.get(currentMetadataValue, 'enabled', false) // enable on display

            return activeMetadataCopy;
          })
          .value();


        const deliveriesMetadata = _.chain(metaData)
          .filter((m) => {
            return (m.holder === 'SERVICE') && !!m.active
          })
          .map((activeMetadata) => {
            const currentMetadataValue = _.find(deliveryLocalSettings.dynamicColumns, (c) => {
              return c.id === activeMetadata.id;
            });
            const activeMetadataCopy = angular.copy(activeMetadata);
            activeMetadataCopy.enabled = _.get(currentMetadataValue, 'enabled', false) // enable on display

            return activeMetadataCopy;
          })
          .value();

        const tasksMetadata = _.chain(metaData)
          .filter((m) => {
            return (m.holder === 'TASK') && !!m.active
          })
          .map((activeMetadata) => {
            const currentMetadataValue = _.find(deliveryLocalSettings.taskDynamicColumns, (c) => {
              return c.id === activeMetadata.id;
            });
            const activeMetadataCopy = angular.copy(activeMetadata);
            activeMetadataCopy.enabled = _.get(currentMetadataValue, 'enabled', false) // enable on display

            return activeMetadataCopy;
          })
          .value();

        const fulfillmentsMetadata = _.chain(metaData)
          .filter((m) => {
            return (m.holder === 'FULFILLMENT') && !!m.active
          })
          .map((activeMetadata) => {
            const currentMetadataValue = _.find(fulfillmentLocalSettings.dynamicColumns, (c) => {
              return c.id === activeMetadata.id;
            });
            const activeMetadataCopy = angular.copy(activeMetadata);
            activeMetadataCopy.enabled = _.get(currentMetadataValue, 'enabled', false) // enable on display

            return activeMetadataCopy;
          })
          .value();

        const thirdPartyServicesMetadata = _.chain(metaData)
          .filter((m) => {
            return (m.holder === 'THIRD_PARTY_SERVICE') && !!m.active
          })
          .map((activeMetadata) => {
            const currentMetadataValue = _.find(thirdPartyServiceLocalSettings.dynamicColumns, (c) => {
              return c.id === activeMetadata.id;
            });
            const activeMetadataCopy = angular.copy(activeMetadata);
            activeMetadataCopy.enabled = _.get(currentMetadataValue, 'enabled', false) // enable on display

            return activeMetadataCopy;
          })
          .value();

        const routesMetadata = _.chain(metaData)
          .filter((m) => {
            return (m.holder === 'ROUTE') && !!m.active
          })
          .map((activeMetadata) => {
            const currentMetadataValue = _.find(routeLocalSettings.dynamicColumns, (c) => {
              return c.id === activeMetadata.id;
            });
            const activeMetadataCopy = angular.copy(activeMetadata);
            activeMetadataCopy.enabled = _.get(currentMetadataValue, 'enabled', false) // enable on display

            return activeMetadataCopy;
          })
          .value();

        const fulfillmentStepMetadata = _.chain(metaData)
          .filter((m) => {
            return (m.holder === 'FULFILLMENT_STEP') && !!m.active
          })
          .map((activeMetadata) => {
            const currentMetadataValue = _.find(fulfillmentStepLocalSettings.dynamicColumns, (c) => {
              return c.id === activeMetadata.id;
            });
            const activeMetadataCopy = angular.copy(activeMetadata);
            activeMetadataCopy.enabled = _.get(currentMetadataValue, 'enabled', false) // enable on display

            return activeMetadataCopy;
          })
          .value();

        // Account Views Settings
        accountLocalSettings.dynamicColumns = accountMetadata;

        // OMS Views Settings
        omsLocalSettings.dynamicColumns = omsMetadata;
        omsLocalSettings.packageDynamicColumns = this._getUpdatedPackagesDynamicColumnsBySiteCustomFields(omsLocalSettings.packageDynamicColumns);

        // Services Views Settings
        deliveryLocalSettings.dynamicColumns = deliveriesMetadata;
        deliveryLocalSettings.taskDynamicColumns = tasksMetadata;
        deliveryLocalSettings.packageDynamicColumns = this._getUpdatedPackagesDynamicColumnsBySiteCustomFields(deliveryLocalSettings.packageDynamicColumns);

        // Fulfillment Views Settings
        fulfillmentLocalSettings.dynamicColumns = fulfillmentsMetadata;
        fulfillmentLocalSettings.packageDynamicColumns = this._getUpdatedPackagesDynamicColumnsBySiteCustomFields(fulfillmentLocalSettings.packageDynamicColumns);

        // Package Details Settings
        packageDetailsLocalSettings.packageDynamicColumns = this._getUpdatedPackagesDynamicColumnsBySiteCustomFields(packageDetailsLocalSettings.packageDynamicColumns);

        // 3pl service view settings
        thirdPartyServiceLocalSettings.dynamicColumns = thirdPartyServicesMetadata;

        // Route settings
        routeLocalSettings.dynamicColumns = routesMetadata;

        // FulfillmentStep settings
        fulfillmentStepLocalSettings.dynamicColumns = fulfillmentStepMetadata;

        this.splitService.setSiteAccountSettings(accountLocalSettings);
        this.splitService.setSiteOmsSettings(omsLocalSettings);
        this.splitService.setSiteDeliverySettings(deliveryLocalSettings);
        this.splitService.setSiteFulfillmentSettings(fulfillmentLocalSettings);
        this.splitService.setSitePackageDetailsSettings(packageDetailsLocalSettings);
        this.splitService.setSite3plServiceSettings(thirdPartyServiceLocalSettings);
        this.splitService.setSitePlanningRoutesSettings(routeLocalSettings);
        this.splitService.setSiteFulfillmentStepSettings(fulfillmentStepLocalSettings);
        this.splitService.setSiteMetaData(metaData);

        deferred.resolve(metaData);
      })
      .catch((error) => {
        this.settingsAlertsService.getGeneralTasksError();
        deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  createMetadata(data) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.settingsRequestsService.createMetadata(data)
      .then((createdMetadata) => {
        deferred.resolve(createdMetadata);
      })
      .catch((error) => {
        this.settingsAlertsService.getGeneralTasksError();
        deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  updateMetadata(id, data) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.settingsRequestsService.updateMetadata(id, data)
      .then((updatedMetadata) => {
        deferred.resolve(updatedMetadata);
      })
      .catch((error) => {
        this.settingsAlertsService.getGeneralTasksError();
        deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  deleteMetadata(id) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.settingsRequestsService.deleteMetadata(id)
      .then((deletedMetadata) => {
        deferred.resolve(deletedMetadata);
      })
      .catch((error) => {
        this.settingsAlertsService.getGeneralTasksError();
        deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  getGeneralTasks(type) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.preferencesRequestsService.getGeneralTasks(type)
      .then((createdTemplate) => {
        deferred.resolve(createdTemplate);
      })
      .catch((error) => {
        this.settingsAlertsService.getGeneralTasksError();
        deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  updateGeneralTask(generalTask) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.preferencesRequestsService.updateGeneralTask(generalTask)
      .then((createdTemplate) => {
        this.settingsAlertsService.updateGeneralTaskSuccess();
        deferred.resolve(createdTemplate);
      })
      .catch((error) => {
        this.settingsAlertsService.updateGeneralTaskError();
        deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

///////////////////////// DOCUMENTS /////////////////////////
  getAllDocuments(holderType: HolderType) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.settingsRequestsService.getDocuments()
      .then((allDocuments) => {

        const filteredDocuments = _.filter(allDocuments, (document: DocumentSettings) => {
          return document.holderType === holderType;
        })

        deferred.resolve(filteredDocuments);
      })
      .catch((error) => {
        this.settingsAlertsService.getDocumentsError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
    return deferred.promise
  }

  createDocument(document: any) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.settingsRequestsService.createDocument(document)
      .then((createdDocument) => {
        deferred.resolve(createdDocument);
        this.settingsAlertsService.createDocumentSuccess();
      })
      .catch((error) => {
        this.settingsAlertsService.createDocumentError();
        deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  updateDocument(document: DocumentSettings) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.settingsRequestsService.updateDocument(document)
      .then((updatedDocument) => {
        deferred.resolve(updatedDocument);
        this.settingsAlertsService.updateDocumentSuccess();
      })
      .catch((error) => {
        this.settingsAlertsService.updateDocumentError();
        deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  deleteDocument(document: any) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.settingsRequestsService.deleteDocument(document)
      .then((deletedDocument) => {
        deferred.resolve(deletedDocument);
        this.settingsAlertsService.deleteDocumentSuccess(document);
      })
      .catch((error) => {
        this.settingsAlertsService.deleteDocumentError();
        deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  ///////////////////////// REMINDERS /////////////////////////

  getAllReminders(holderType: HolderType) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.settingsRequestsService.getReminders()
      .then((allReminders) => {
        const filteredReminders = _.filter(allReminders, (reminder: ReminderSettings) => {
          return reminder.holderType === holderType;
        })

        deferred.resolve(filteredReminders);
      })
      .catch((error) => {
        this.settingsAlertsService.getRemindersError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
    return deferred.promise
  }

  createReminder(reminder: ReminderSettings) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.settingsRequestsService.createReminder(reminder)
      .then((createdReminder) => {
        deferred.resolve(createdReminder);
        this.settingsAlertsService.createReminderSuccess();
      })
      .catch((error) => {
        this.settingsAlertsService.createReminderError();
        deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  updateReminder(reminder: ReminderSettings) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.settingsRequestsService.updateReminder(reminder)
      .then((updatedReminder) => {
        deferred.resolve(updatedReminder);
        this.settingsAlertsService.updateReminderSuccess();
      })
      .catch((error) => {
        this.settingsAlertsService.updateReminderError();
        deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  deleteReminder(reminder: ReminderSettings) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.settingsRequestsService.deleteReminder(reminder)
      .then(() => {
        deferred.resolve();
        this.settingsAlertsService.deleteReminderSuccess(reminder);
      })
      .catch((error) => {
        this.settingsAlertsService.deleteReminderError();
        deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  ///////////////////////// Vehicle Status Change Reason /////////////////////////
  getAllVehicleStatusChangeReason(): IPromise<VehicleStatusChangeReasonSettingsEntity[]> {
    const deferred = this.$q.defer<VehicleStatusChangeReasonSettingsEntity[]>();

    this.bringozLoaderService.on();
    this.settingsRequestsService.getAllVehicleStatusChangeReason()
      .then((vehicleStatusChangeReason) => {
        deferred.resolve(vehicleStatusChangeReason as VehicleStatusChangeReasonSettingsEntity[]);
      })
      .catch((error) => {
        this.settingsAlertsService.getAllVehicleStatusChangeReasonError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
    return deferred.promise
  }

  createVehicleStatusChangeReason(vehicleStatusChangeReason: VehicleStatusChangeReasonSettingsEntity): IPromise<VehicleStatusChangeReasonSettingsEntity> {
    const deferred = this.$q.defer<VehicleStatusChangeReasonSettingsEntity>();

    this.bringozLoaderService.on();
    this.settingsRequestsService.createVehicleStatusChangeReason(vehicleStatusChangeReason)
      .then((createdVehicleStatusChangeReason) => {
        deferred.resolve(createdVehicleStatusChangeReason);
        this.settingsAlertsService.createVehicleStatusChangeReasonSuccess();
      })
      .catch((error) => {
        this.settingsAlertsService.createVehicleStatusChangeReasonError();
        deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  updateVehicleStatusChangeReason(vehicleStatusChangeReason: VehicleStatusChangeReasonSettingsEntity) {
    const deferred = this.$q.defer<VehicleStatusChangeReasonSettingsEntity>();

    this.bringozLoaderService.on();
    this.settingsRequestsService.updateVehicleStatusChangeReason(vehicleStatusChangeReason)
      .then((updatedvehicleStatusChangeReason) => {
        deferred.resolve(updatedvehicleStatusChangeReason);
        this.settingsAlertsService.updateVehicleStatusChangeReasonSuccess();
      })
      .catch((error) => {
        this.settingsAlertsService.updateVehicleStatusChangeReasonError();
        deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  deleteVehicleStatusChangeReason(vehicleStatusChangeReason: VehicleStatusChangeReasonSettingsEntity) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.settingsRequestsService.deleteVehicleStatusChangeReason(vehicleStatusChangeReason)
      .then(() => {
        deferred.resolve();
        this.settingsAlertsService.deleteVehicleStatusChangeReasonSuccess(vehicleStatusChangeReason);
      })
      .catch((error) => {
        this.settingsAlertsService.deleteVehicleStatusChangeReasonError();
        deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  getOneVehicleStatusChangeReason(id: string) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.settingsRequestsService.getOneVehicleStatusChangeReason(id)
      .then((vehicleStatusChange: VehicleStatusChangeReasonSettingsEntity) => {
        deferred.resolve(vehicleStatusChange);
      })
      .catch((error) => {
        this.settingsAlertsService.getOneVehicleStatusChangeReasonError();
        deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  //////////////////////////////////////// Package Configuration ////////////////////////////////////////

  getPackageFields(): IPromise<any[]> {
    const deferred = this.$q.defer<CustomFieldModel[]>();

    this.bringozLoaderService.on();
    this.packageConfigurationsRequestsService.getPackageFields()
      .then((packageConfigurations: CustomFieldModel[]) => {
        deferred.resolve(packageConfigurations);
      })
      .catch((error) => {
        this.settingsAlertsService.getAllPackageConfigurationsError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
    return deferred.promise
  }

  createPackageField(field: CustomFieldModel): IPromise<CustomFieldModel> {
    const deferred = this.$q.defer<CustomFieldModel>();

    this.bringozLoaderService.on();
    this.packageConfigurationsRequestsService.createPackageField(field)
      .then((field: CustomFieldModel) => {
        this.settingsAlertsService.createCustomFieldSuccess();
        deferred.resolve(field);
      })
      .catch((error) => {
        this.settingsAlertsService.createCustomFieldError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
    return deferred.promise
  }

  updatePackageField(id: string, field: CustomFieldModel): IPromise<CustomFieldModel> {
    const deferred = this.$q.defer<CustomFieldModel>();

    this.bringozLoaderService.on();
    this.packageConfigurationsRequestsService.updatePackageField(id, field)
      .then((field: CustomFieldModel) => {
        this.settingsAlertsService.updateCustomFieldSuccess();
        deferred.resolve(field);
      })
      .catch((error) => {
        this.settingsAlertsService.updateCustomFieldError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
    return deferred.promise
  }

  deletePackageField(id: string): IPromise<CustomFieldModel> {
    const deferred = this.$q.defer<CustomFieldModel>();

    this.bringozLoaderService.on();
    this.packageConfigurationsRequestsService.deletePackageField(id)
      .then((field: CustomFieldModel) => {
        this.settingsAlertsService.deleteCustomFieldSuccess();
        deferred.resolve(field);
      })
      .catch((error) => {
        this.settingsAlertsService.deleteCustomFieldError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
    return deferred.promise
  }

  getAllPackageConfigurations(): IPromise<PackageConfigurationEntity[]> {
    const deferred = this.$q.defer<PackageConfigurationEntity[]>();

    this.bringozLoaderService.on();
    this.packageConfigurationsRequestsService.getAllPackageConfigurations()
      .then((packageConfigurations) => {
        deferred.resolve(packageConfigurations as PackageConfigurationEntity[]);
      })
      .catch((error) => {
        this.settingsAlertsService.getAllPackageConfigurationsError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
    return deferred.promise
  }

  getOnePackageConfiguration(packageId: string): IPromise<PackageConfigurationEntity> {
    const deferred = this.$q.defer<PackageConfigurationEntity>();

    this.bringozLoaderService.on();
    this.packageConfigurationsRequestsService.getOnePackageConfiguration(packageId)
      .then((packageConfigurations) => {
        deferred.resolve(packageConfigurations as PackageConfigurationEntity);
      })
      .catch((error) => {
        this.settingsAlertsService.getOnePackageConfigurationError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
    return deferred.promise
  }

  updatePackageConfiguration(packageConfiguration: PackageConfigurationEntity): IPromise<PackageConfigurationEntity> {
    const deferred = this.$q.defer<PackageConfigurationEntity>();

    this.bringozLoaderService.on();
    this.packageConfigurationsRequestsService.updatePackageConfiguration(packageConfiguration)
      .then((packageConfiguration) => {
        this.settingsAlertsService.updatePackageConfigurationSuccess();

        deferred.resolve(packageConfiguration as PackageConfigurationEntity);
      })
      .catch((error) => {
        this.settingsAlertsService.updatePackageConfigurationError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
    return deferred.promise
  }

  createPackageConfiguration(packageConfiguration: PackageConfigurationEntity): IPromise<PackageConfigurationEntity> {
    const deferred = this.$q.defer<PackageConfigurationEntity>();

    this.bringozLoaderService.on();
    this.packageConfigurationsRequestsService.createPackageConfiguration(packageConfiguration)
      .then((packageConfiguration) => {
        this.settingsAlertsService.createPackageConfigurationSuccess();

        deferred.resolve(packageConfiguration as PackageConfigurationEntity);
      })
      .catch((error) => {
        this.settingsAlertsService.createPackageConfigurationError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
    return deferred.promise
  }

  //////////////////////////////////////// Absence Reasons ////////////////////////////////////////

  getAbsenceReasons() {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.settingsRequestsService.getAbsenceReasons()
      .then(absenceReasons => {
        deferred.resolve(absenceReasons);
        // this.settingsAlertsService.createReminderSuccess();
      })
      .catch((error) => {
        // this.settingsAlertsService.createReminderError();
        deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  createAbsenceReason(absenceReason: AbsenceReasonSettings) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.settingsRequestsService.createAbsenceReason(absenceReason)
      .then(createdAbsenceReason => {
        deferred.resolve(createdAbsenceReason);
        this.settingsAlertsService.createAbsenceReasonSuccess();
      })
      .catch((error) => {
        this.settingsAlertsService.createAbsenceReasonError();
        deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  updateAbsenceReason(absenceReason: AbsenceReasonSettings) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.settingsRequestsService.updateAbsenceReason(absenceReason)
      .then(updatedAbsenceReason => {
        deferred.resolve(updatedAbsenceReason);
        this.settingsAlertsService.updateAbsenceReasonSuccess();
      })
      .catch((error) => {
        this.settingsAlertsService.updateAbsenceReasonError();
        deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  deleteAbsenceReason(absenceReasonId) {

    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.settingsRequestsService.deleteAbsenceReason(absenceReasonId)
      .then(() => {
        deferred.resolve();
        this.settingsAlertsService.deleteAbsenceReasonSuccess();
      })
      .catch((error) => {
        this.settingsAlertsService.deleteAbsenceReasonError();
        deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  //////////////////////////////////////// Break Types ////////////////////////////////////////

  createBreakType(breakType: BreakType): IPromise<BreakType> {
    const deferred = this.$q.defer<BreakType>();

    this.bringozLoaderService.on();
    this.settingsRequestsService.createBreakType(breakType)
      .then((createdBreakType: BreakType) => {
        deferred.resolve(createdBreakType);
        this.settingsAlertsService.createBreakTypeSuccess();
      })
      .catch((error) => {
        this.settingsAlertsService.createBreakTypeError(error);
        deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  updateBreakType(breakType: BreakType): IPromise<BreakType> {
    const deferred = this.$q.defer<BreakType>();

    this.bringozLoaderService.on();
    this.settingsRequestsService.updateBreakType(breakType)
      .then((updatedBreakType: BreakType) => {
        deferred.resolve(updatedBreakType);
        this.settingsAlertsService.updateBreakTypeSuccess();
      })
      .catch((error) => {
        this.settingsAlertsService.updateBreakTypeError(error);
        deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  deleteBreakType(breakTypeId: string) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.settingsRequestsService.deleteBreakType(breakTypeId)
      .then(() => {
        deferred.resolve();
        this.settingsAlertsService.deleteBreakTypeSuccess();
      })
      .catch((error) => {
        this.settingsAlertsService.deleteBreakTypeError();
        deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  getGenericPackageConfigurationFieldByName(defaultFieldsType: DefaultPackageConfigurationFieldsType) {
    return this.splitService.getSiteDefaultPackageConfigurationFields().find((f) => f.name === defaultFieldsType);
  }

  updateOrderShipperAppConfig(payload: SHIPPER_APP_ORDER_CONFIGURATION) {

    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.settingsRequestsService.updateOrderShipperAppConfig(payload)
      .then((res: SHIPPER_APP_ORDER_CONFIGURATION) => {
        this.settingsAlertsService.shipperPortalConfigurationEditSuccess();
        deferred.resolve(res);
      })
      .catch((error) => {
        this.settingsAlertsService.shipperPortalConfigurationEditError();
        deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  updateCustomerShipperAppConfig(payload: SHIPPER_APP_CUSTOMER_CONFIGURATION) {

    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.settingsRequestsService.updateCustomerShipperAppConfig(payload)
      .then((res: SHIPPER_APP_CUSTOMER_CONFIGURATION) => {
        this.settingsAlertsService.shipperPortalConfigurationEditSuccess();
        deferred.resolve(res);
      })
      .catch((error) => {
        this.settingsAlertsService.shipperPortalConfigurationEditError();
        deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  updatePaymentShipperAppConfig(payload: SHIPPER_APP_PAYMENT_CONFIGURATION) {

    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.settingsRequestsService.updatePaymentShipperAppConfig(payload)
      .then((res: SHIPPER_APP_PAYMENT_CONFIGURATION) => {
        this.settingsAlertsService.shipperPortalConfigurationEditSuccess();
        deferred.resolve(res);
      })
      .catch((error) => {
        this.settingsAlertsService.shipperPortalConfigurationEditError();
        deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  createEmailReportConfiguration(emailReportTemplateCofiguration) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.settingsRequestsService.createEmailReportConfiguration(emailReportTemplateCofiguration)
      .then((emailReportTemplate) => {
        this.settingsAlertsService.createEmailReportConfigurationSuccess();
        deferred.resolve(emailReportTemplate);
      })
      .catch((error) => {
        this.settingsAlertsService.createEmailReportConfigurationError();
        deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  editEmailReportConfiguration(emailReportTemplateCofiguration, emailReportType) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.settingsRequestsService.updateEmailReportConfiguration(emailReportTemplateCofiguration, emailReportType)
      .then((emailReportTemplate) => {
        this.settingsAlertsService.updateEmailReportConfigurationSuccess();
        deferred.resolve(emailReportTemplate);
      })
      .catch((error) => {
        this.settingsAlertsService.updateEmailReportConfigurationError();
        deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  private _getUpdatedPackagesDynamicColumnsBySiteCustomFields(packageDynamicColumns?) {
    const customPackagesFields = this.splitService.getCustomPackageFields();
    return _.map(customPackagesFields, (cf: CustomFieldModel) => {
      const columnSettings = _.find(packageDynamicColumns, (c: { id: string, key: string, title: string, enabled: any }) => {
        return c.id === cf.id;
      }) || {
        id: cf.id,
        key: cf.name,
        title: cf.name,
        enabled: false
      };

      columnSettings.key = cf.name; // Check if can be removed.
      columnSettings.title = cf.name;
      return columnSettings;
    });
  }
}

angular
  .module('bringoz.admin.site-preferences')
  .service('settingsService', SettingsService);
